/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import companyService from '../../services/CompanyService';
import CompanyTypes from '../types/CompanyTypes';

//* get all department list items
function getAll(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: CompanyTypes.GET_COMPANY_LIST_REQUEST });
    try {
      const res = await companyService.getAll(pageOption, sortData, keyword);
      dispatch({
        type: CompanyTypes.GET_COMPANY_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CompanyTypes.GET_COMPANY_LIST_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

const updateQueryParams = (paging, sorting, keyword) => ({
  type: CompanyTypes.UPDATE_COMPANY_QUERY_PARAMS,
  payload: { paging, sorting, keyword }
});

function add(postData, setErrors, submitting, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: CompanyTypes.ADD_COMPANY_REQUEST });
    try {
      const res = await companyService.add(postData);
      dispatch({ type: CompanyTypes.ADD_COMPANY_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().company.queryParams;
      setTimeout(() => dispatch(CompanyAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      closeModal();
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: CompanyTypes.ADD_COMPANY_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: CompanyTypes.GET_COMPANY_ITEM_REQUEST });
    try {
      const res = await companyService.getItem(code);
      dispatch({
        type: CompanyTypes.GET_COMPANY_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CompanyTypes.GET_COMPANY_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function update(code, postData, setErrors, submitting, navigate) {
  return async (dispatch, getState) => {
    dispatch({ type: CompanyTypes.UPDATE_COMPANY_REQUEST });
    try {
      const res = await companyService.update(code, postData);
      dispatch({
        type: CompanyTypes.UPDATE_COMPANY_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().company.queryParams;
      setTimeout(() => dispatch(CompanyAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      navigate('/');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: CompanyTypes.UPDATE_COMPANY_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteItem(code, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: CompanyTypes.DELETE_COMPANY_REQUEST });
    try {
      const res = await companyService.deleteItem(code);
      dispatch({
        type: CompanyTypes.DELETE_COMPANY_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().company.queryParams;
      setTimeout(() => dispatch(CompanyAction.getAll(paginationData, sortingData, keyword)), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CompanyTypes.DELETE_COMPANY_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getActiveItem() {
  return async (dispatch) => {
    dispatch({ type: CompanyTypes.GET_COMPANY_ACTIVE_REQUEST });
    try {
      const res = await companyService.getActiveItem();
      dispatch({
        type: CompanyTypes.GET_COMPANY_ACTIVE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: CompanyTypes.GET_COMPANY_ACTIVE_ERROR,
          error: error.response
        });
      }
    }
  };
}

const CompanyAction = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem,
  updateQueryParams
};

export default CompanyAction;
